import mutations from './moduleOfflineDonationsMutations.js';
import actions from './moduleOfflineDonationsActions.js';
import getters from './moduleOfflineDonationsGetters.js';
import { getDefaultState } from './constants.js';

export default {
  isRegistered: false,
  namespaced: true,
  state: getDefaultState(),
  mutations,
  actions,
  getters,
};
